import React, { useEffect } from 'react';
import { useFormValidator  } from '../hooks';
import hoistNonReactStatic from 'hoist-non-react-statics';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

const withFormValidation = (WrappedComponent, rules, message) => {

  const WithFormValidationComponent =  (props) => {
    
    const formValidator = useFormValidator(props.value, rules, message)
    
    useEffect(() => {
      formValidator.validate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Object.values(props.value).join(',')])

    return (
      <WrappedComponent 
        onSetObjectRules={formValidator.onSetObjectRules}
        isPassed={formValidator.response.is_passed}
        helperMessage={formValidator.renderMessage}
        useFormValidator={useFormValidator}
        {...props}
      />
    )
  }
  
  WithFormValidationComponent.displayName = `WithFormComponent(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatic(WithFormValidationComponent, WrappedComponent);
  return WithFormValidationComponent
}

export default withFormValidation;